import { client } from '../http';

export default {
  async getCustomerDetails() {
    const response = await client.get('/api/restricted-customer/');
    return response.data;
  },
  async getOnboradingStatus() {
    const response = await client.get('/api/customer/onboarding-status');
    return response.data;
  },
  async getMembers() {
    const response = await client.get('/api/restricted-customer/members');
    return response.data;
  },
  async churn() {
    return client.delete('/api/churn');
  },
};



// WEBPACK FOOTER //
// ./src/api/CustomersApi.js